import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';

const SidebarItem = ({ title, path, icon, alternative_path, only_icon }) => {
  const location = useLocation();
  const isActive = location.pathname === path || alternative_path?.some((name) => location.pathname.split("").slice(1).join("").includes(name));
  // console.log({ location });
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(path);
  };

  return (
    <>
      <Tooltip title={title}>
        <Box
          className={`flex flex-row justify-start items-center px-3 py-[12px] gap-3 w-full cursor-pointer ${isActive ? 'primary-p10' : 'neutral-n10'
            }`}
          onClick={handleNavigate}
          sx={{
            bgcolor: isActive ? 'secondary.light' : '',
            ":hover": {
              backgroundColor: 'secondary.light'
            }
          }}
        >
          <Box>{icon}</Box>
          {
            !only_icon &&
            <Box className="text-center">
              <Typography>{title}</Typography>
            </Box>
          }
        </Box>
      </Tooltip>
    </>
  );
};

export default SidebarItem;
